import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Checkbox } from 'antd';
import { DesignModal } from '../styles';
import { AppStoreContext } from '../../../context/appStoreContext';
import { REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL } from './translationValues';
import { IS_WHATSAPP_ENABLED } from '../../../utils/helper';

/* This component handle requesting for approval and publishing the created short messages
  Child Components: 
    *********
*/
const NAMESPACES = ['REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL'];
class ShortMessageOnComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.templateId,
      isLoading: false,
      checkedList: [],
      modalTitle: this.props.t(
        REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.REQUEST_FOR_APPROVAL_TITLE.key,
        REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.REQUEST_FOR_APPROVAL_TITLE.value,
      ),
    };
  }
  static contextType = AppStoreContext;

  componentDidMount = () => {
    const { t } = this.props;
    this.state.checkedList.length === 1
      ? this.setState({
          modalTitle: this.props.isPublish
            ? t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CHOOSE_A_CHANNEL_TO_PUBLISH_TITLE.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CHOOSE_A_CHANNEL_TO_PUBLISH_TITLE.value,
              )
            : t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL
                  .CHOOSE_A_CHANNEL_TO_REQUEST_FOR_APPROVAL_TITLE.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL
                  .CHOOSE_A_CHANNEL_TO_REQUEST_FOR_APPROVAL_TITLE.value,
              ),
        })
      : this.setState({
          modalTitle: this.props.isPublish
            ? t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.PUBLISH_TITLE.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.PUBLISH_TITLE.value,
              )
            : t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.REQUEST_FOR_APPROVAL_TITLE.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.REQUEST_FOR_APPROVAL_TITLE.value,
              ),
        });
    this.setState({ checkedList: this.props.testingStatus });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.testingStatus !== prevProps.testingStatus) {
      this.setState({
        checkedList: this.props.testingStatus,
      });
    }
  }

  onChange = list => {
    let checkedList = this.state.checkedList;
    if (checkedList?.includes(list)) {
      let newVar = checkedList?.filter(value => value !== list);
      this.setState({ checkedList: newVar });
    } else {
      this.setState({ checkedList: [...checkedList, list] });
    }
  };

  checkSVG = () => {
    return (
      <div className="ModalCheck">
        <svg
          className="ModalGreenTick"
          xmlns="http://www.w3.org/2000/svg"
          height="20"
          width="20"
          viewBox="0 0 48 48"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="modalGradient">
              <stop offset="0%" stop-color="#900c3f" />
              <stop offset="50%" stop-color="#c70039" />
              <stop offset="100%" stop-color="#900c3f" />
            </linearGradient>
          </defs>
          <circle className="ModalCircle" fill="#5bb543" cx="24" cy="24" r="22" />
          <path
            className="ModalTick"
            fill="none"
            stroke="#FFF"
            stroke-width="6"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            d="M14 27l5.917 4.917L34 17"
          />
        </svg>
      </div>
    );
  };

  render() {
    const { checkedList, modalTitle } = this.state;
    const { isLoading, onCancel, testingStatus, requestForApproval, isPublish, t } = this.props;

    return (
      <DesignModal
        messageStudio={true}
        reqApprovalButton={true}
        title={modalTitle}
        width="600px"
        centered
        maskClosable={false}
        visible={true}
        onCancel={() => onCancel()}
        footer={[
          checkedList?.length === 0
            ? [
                <p className="ErrorMsg">
                  {t(
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SELECT_A_CHANNEL_ERROR_MESSAGE.key,
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SELECT_A_CHANNEL_ERROR_MESSAGE.value,
                  )}
                </p>,
              ]
            : [],
          <div>
            <Button key="back" onClick={() => onCancel()}>
              {t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CANCEL_REQUEST_OR_PUBLISH_BUTTON.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CANCEL_REQUEST_OR_PUBLISH_BUTTON.value,
              )}
            </Button>
            <Button
              width={'600px'}
              key="Request for Approval"
              type="primary"
              disabled={checkedList?.length === 0 ? true : false}
              loading={isLoading}
              onClick={() => requestForApproval(checkedList)}
            >
              {isPublish
                ? isLoading
                  ? t(
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.PUBLISHING_CHANNELS_BUTTON.key,
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.PUBLISHING_CHANNELS_BUTTON.value,
                    )
                  : t(
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.PUBLISH_CHANNELS_BUTTON.key,
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.PUBLISH_CHANNELS_BUTTON.value,
                    )
                : isLoading
                ? t(
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.REQUESTING_FOR_APPROVAL_BUTTON.key,
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.REQUESTING_FOR_APPROVAL_BUTTON.value,
                  )
                : t(
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.REQUEST_FOR_APPROVAL_BUTTON.key,
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.REQUEST_FOR_APPROVAL_BUTTON.value,
                  )}
            </Button>
          </div>,
        ]}
      >
        {testingStatus?.length > 0 &&
          testingStatus?.map(li => {
            return (
              <Checkbox onChange={() => this.onChange(li)}>
                {IS_WHATSAPP_ENABLED && li === 'whatsapp'
                  ? t(
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.WHATSAPP_MESSAGE_CHANNEL_NAME.key,
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.WHATSAPP_MESSAGE_CHANNEL_NAME.value,
                    )
                  : li === 'sms'
                  ? t(
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SMS_CHANNEL_NAME.key,
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SMS_CHANNEL_NAME.value,
                    )
                  : t(
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_CHANNEL_NAME.key,
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_CHANNEL_NAME.value,
                    )}
                {checkedList?.includes(li) && this.checkSVG()}
              </Checkbox>
            );
          })}
      </DesignModal>
    );
  }
}

export default withTranslation(NAMESPACES)(ShortMessageOnComplete);
